import React from "react";
import LangSwitcher from "../langSwitcher";
import { Slang } from "../../helpers";

const Footer = ({ sub }) => {
  const lang = Slang("footer");
  const accountLang = Slang("footer.account");
  const companyLang = Slang("footer.company");
  const resourcesLang = Slang("footer.resources");

  return (
    <>
      <footer className="border-top">
        <div className="container">
          <div className="row justify-content-lg-between content-space-t-2 content-space-b-lg-2">
            <div className="col-lg-3 mb-5">
              <div className="d-flex align-items-start flex-column h-100">
                <a className="w-100 mb-3 mb-lg-auto" href="/" aria-label="ABN">
                  {/* <img className="brand" src="./assets/img/testfooter.png" alt="Logo"/> */}
                  <img
                    className="brand"
                    src={`${(sub = "market-place"
                      ? "../.."
                      : sub
                      ? ".."
                      : ".")}/assets/img/logos/200x47/PNG/Groupe6.png`}
                    alt="Logo"
                  />
                </a>

                <p className="text-muted small mb-0">
                  © African Business Network (ABN). 2024.
                </p>
              </div>
            </div>

            <div className="col-6 col-md-4 col-lg-3 ms-lg-auto mb-5 mb-lg-0">
              <h5 className="text-secondary">{accountLang("t1")}</h5>

              <ul className="list-unstyled list-py-1">
                <li>
                  <a className="link-sm link-primary" href="#">
                    {accountLang("t2")}
                  </a>
                </li>
                <li>
                  <a className="link-sm link-primary" href="#">
                    {accountLang("t3")}
                  </a>
                </li>
                <li>
                  <a className="link-sm link-primary" href="#">
                    {accountLang("t4")}
                  </a>
                </li>
                <li>
                  <a className="link-sm link-primary" href="#">
                    {accountLang("t5")}
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-6 col-md-4 col-lg-3 mb-5 mb-lg-0">
              <h5 className="text-secondary">{companyLang("t1")}</h5>

              <ul className="list-unstyled list-py-1">
                <li>
                  <a className="link-sm link-primary" href="#">
                    {companyLang("t2")}
                  </a>
                </li>
                <li>
                  <a className="link-sm link-primary" href="#">
                    {companyLang("t3")}
                  </a>
                </li>
                <li>
                  <a className="link-sm link-primary" href="#">
                    {companyLang("t4")}
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-md-4 col-lg-2 mb-5 mb-lg-0">
              <h5 className="mb-3 text-secondary">{resourcesLang("t1")}</h5>

              <ul className="list-unstyled list-py-1">
                <li>
                  <a className="link-sm link-primary" href="#">
                    <i className="bi-question-circle-fill me-1"></i>
                    {resourcesLang("t2")}
                  </a>
                </li>
                <li>
                  <a className="link-sm link-primary" href="#">
                    <i className="bi-person-circle me-1"></i>
                    {resourcesLang("t2")}
                  </a>
                </li>
              </ul>

              <div className="btn-group">
                <LangSwitcher sub={sub} />
              </div>
            </div>
          </div>

          <hr className="my-0" />

          <div className="row align-items-sm-center content-space-1">
            <div className="col-sm mb-4 mb-sm-0">
              <ul className="list-inline mb-0">
                <li className="list-inline-item">
                  <a className="btn btn-soft-primary btn-xs btn-icon" href="#">
                    <i className="bi-facebook"></i>
                  </a>
                </li>

                <li className="list-inline-item">
                  <a className="btn btn-soft-primary btn-xs btn-icon" href="#">
                    <i className="bi-google"></i>
                  </a>
                </li>

                <li className="list-inline-item">
                  <a className="btn btn-soft-primary btn-xs btn-icon" href="#">
                    <i className="bi-twitter"></i>
                  </a>
                </li>

                <li className="list-inline-item">
                  <a className="btn btn-soft-primary btn-xs btn-icon" href="#">
                    <i className="bi-github"></i>
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-sm-auto">
              <ul className="list-inline list-separator">
                <li className="list-inline-item">
                  <a
                    className="link-sm link-primary"
                    href="../page-privacy.html"
                  >
                    {lang("info1")}
                  </a>
                </li>
                <li className="list-inline-item">
                  <a className="link-sm link-primary" href="../page-terms.html">
                    {lang("info2")}
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    className="link-sm link-primary"
                    href="../page-careers.html"
                  >
                    {lang("info3")}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
